import React from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { useTranslation } from 'react-i18next';

const ViceDeanCard = ({ name, title, email, imageUrl }) => {
    const { t } = useTranslation();
    return (
        <div className="bg-white rounded-lg shadow-lg p-6 flex flex-col items-center text-center transition-all duration-300 hover:shadow-xl hover:-translate-y-1">
            <img 
                src={imageUrl}
                alt={name}
                className="w-32 h-32 rounded-full object-cover mb-4 border-4 border-blue-200 shadow-md"
            />
            <h3 className="text-xl font-bold text-gray-800 mb-1">{name}</h3>
            <p className="text-blue-600 font-semibold mb-2">{title}</p>
            <a href={`mailto:${email}`} className="text-gray-600 hover:text-blue-700 transition-colors duration-200">
                {t('email')}: {email}
            </a>
        </div>
    );
};

const ViceDeans = () => {
    const { t } = useTranslation();

    const viceDeansData = t('vice_deans.deans', { returnObjects: true });

    return (
        <PageTemplate 
            title={t('vice_deans.title')}
            subtitle={t('vice_deans.subtitle')}
        >
            <div className="container mx-auto px-4 py-8">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 justify-items-center">
                    {viceDeansData && viceDeansData.map((dean, index) => (
                        <ViceDeanCard key={index} {...dean} />
                    ))}
                </div>
            </div>
        </PageTemplate>
    );
};

export default ViceDeans;
